import { generateContract } from '@scripts/utils/generateContract';
import Alpine from 'alpinejs';

Alpine.data('personal', (adminURL, rawData, postId) => ({
  adminURL,
  errors: [],
  loading: false,
  generatingModal: false,
  data: {
    name_surname: '',
    second_name: '',
    address: '',
    flat_number: '',
    city: '',
    pesel: '',
    phone: '',
    dial_code: '+48',
    message: '',
    postal_code: '',
    // capcha: false,
    consent: false,
    rodo: false,
    changes: false,
    persona: false,
    health_fund: '',
    declaration: '',
  },
  toggleCaptcha() {
    grecaptcha.ready(() => {
      grecaptcha
        .execute('6LepR_IpAAAAAELXjB_4ernoy4JRKV7llnE8NQnW', {
          action: 'submit',
        })
        .then((token) => {
          // fetch('https://www.google.com/recaptcha/api/siteverify', {
          //   method: 'POST',
          //   headers: ['Content-Type', 'application/x-www-form-urlencoded'],
          //   body: {
          //     secret: '6Lchz_EpAAAAAPvKJ4D_iioPUcZoHtArPduyBzUz',
          //     response: token,
          //   },
          // })
          //   .then((res) => res.json())
          //   .then((res) => {
          //     console.log('xdxd', res);
          //     this.data.captcha = true;
          //   });
          if (token) {
            setTimeout(() => {
              this.data.captcha = true;
            }, 500);
          }
        });
    });
  },
  init() {
    let data = rawData && JSON.parse(rawData);

    for (const key in data) {
      data[key] = data[key] === 'undefined' ? '' : data[key];
    }

    if (data) {
      const [dial_code, phone] = data.phone_number.split(' ');
      this.data.name_surname = data.name_surname;
      this.data.second_name = data.second_name;
      this.data.mother_name = data.mother_name;
      this.data.address = data.address;
      this.data.flat_number = data.flat_number;
      this.data.city = data.city;
      this.data.pesel = data.pesel;
      this.data.phone = phone;
      this.data.dial_code = dial_code;
      this.data.postal_code = data.postal_code;
      this.data.message = data.message;
      this.data.is_company = data.is_company;

      this.data.father_name = data.father_name;
      this.data.email = data.email;
      this.data.id_card = data.id_card;
      this.data.family_name = data.family_name;
      this.data.birthday = data.birthday;
      this.data.voivodeship = data.voivodeship;
      this.data.county = data.county;
      this.data.post = data.post;
      this.data.tax_office = data.tax_office;
      this.data.correspondence_address = data.correspondence_address;
      this.data.bank_name = data.bank_name;
      this.data.bank_accounting = data.bank_accounting;
      this.data.health_fund = data.health_fund;
      this.data.declaration = data.declaration;
      this.data.persona = data.persona;
      this.data.changes = data.changes;

      if (data.is_company) {
        this.data.company_name = data.company_name;
        this.data.company_address = data.company_address;
        this.data.company_nip = data.company_nip;
        this.data.company_flat_number = data.company_flat_number;
        this.data.company_postal_code = data.company_postal_code;
        this.data.company_city = data.company_city;
      }
    }
  },
  get isDataValid() {
    const {
      consent,
      rodo,
      changes,
      persona,
      captcha,
      name_surname,
      address,
      postal_code,
      city,
      pesel,
      is_company,
      company_address,
      company_postal_code,
      company_city,
      declaration,
      health_fund,
    } = this.data;

    const companyCondition = is_company
      ? company_address && company_postal_code && company_city
      : true;

    return (
      rodo &&
      consent &&
      changes &&
      persona &&
      captcha &&
      name_surname &&
      address &&
      postal_code &&
      city &&
      pesel &&
      declaration &&
      health_fund &&
      companyCondition
    );
  },
  fillForm() {
    const form = document.querySelector('.wpcf7');

    form.querySelector('input[name="name_surname"]').value =
      this.data.name_surname;
    form.querySelector('input[name="second_name"]').value =
      this.data.second_name;
    form.querySelector('input[name="mother_name"]').value =
      this.data.mother_name;
    form.querySelector('input[name="address"]').value = this.data.address;
    form.querySelector('input[name="flat_number"]').value =
      this.data.flat_number;
    form.querySelector('input[name="postal_code"]').value =
      this.data.postal_code;
    form.querySelector('input[name="city"]').value = this.data.city;
    form.querySelector('input[name="pesel"]').value = this.data.pesel;
    form.querySelector(
      'input[name="phone_number"]'
    ).value = `${this.data.dial_code} ${this.data.phone}`;
    form.querySelector('input[name="message"]').value = this.data.message;
    form.querySelector('input[name="is_company"]').value = this.data.is_company;
    form.querySelector('input[name="company_name"]').value =
      this.data.company_name;
    form.querySelector('input[name="company_nip"]').value =
      this.data.company_nip;
    form.querySelector('input[name="company_address"]').value =
      this.data.company_address;
    form.querySelector('input[name="company_flat_number"]').value =
      this.data.company_flat_number;
    form.querySelector('input[name="company_postal_code"]').value =
      this.data.company_postal_code;
    form.querySelector('input[name="company_city"]').value =
      this.data.company_city;

    form.querySelector('input[name="father_name"]').value =
      this.data.father_name;
    form.querySelector('input[name="email"]').value = this.data.email;
    form.querySelector('input[name="id_card"]').value = this.data.id_card;
    form.querySelector('input[name="family_name"]').value =
      this.data.family_name;
    form.querySelector('input[name="birthday"]').value = this.data.birthday;
    form.querySelector('input[name="voivodeship"]').value =
      this.data.voivodeship;
    form.querySelector('input[name="county"]').value = this.data.county;
    form.querySelector('input[name="post"]').value = this.data.post;
    form.querySelector('input[name="tax_office"]').value = this.data.tax_office;
    form.querySelector('input[name="correspondence_address"]').value =
      this.data.correspondence_address;
    form.querySelector('input[name="bank_name"]').value = this.data.bank_name;
    form.querySelector('input[name="bank_accounting"]').value =
      this.data.bank_accounting;
    form.querySelector('input[name="health_fund"]').value =
      this.data.health_fund;
    form.querySelector('input[name="declaration"]').value =
      this.data.declaration;
  },
  setFilter(e) {
    const { name, by } = e.detail;

    if (name === 'health_fund') {
      this.data.health_fund = by;
    }

    if (name === 'declaration') {
      this.data.declaration = by;
    }
  },
  changeDialCodes(e) {
    this.data.dial_code = `${e.detail.by}`;
  },
  changeField() {},
  validData() {
    this.errors = [];


    if (this.data.birthday.length != 10) {
      this.errors.push('Rok urodzenia jest nieprawidłowy.');
    }

    if (this.data.pesel.length != 11) {
      this.errors.push('Pesel jest nieprawidłowy.');
    }

    if (this.data.postal_code.length < 6) {
      this.errors.push('Kod pocztowy jest nieprawidłowy.');
    }

    if (this.data.is_company && this.data.company_postal_code.length < 6) {
      this.errors.push('Kod pocztowy firmy jest nieprawidłowy.');
    }
    if (this.data.is_company && this.data.company_nip.length != 10) {
      this.errors.push('Numer NIP firmy jest nieprawidłowy.');
    }

    return !this.errors.length;
  },
  async submit(e) {
    e.preventDefault();

    if (!this.validData()) return;

    const form = document.querySelector('.wpcf7-form');

    this.loading = true;

    this.fillForm();

    const formData = new FormData();

    formData.append('action', 'createContract');

    formData.append('name_surname', this.data.name_surname);
    formData.append('second_name', this.data.second_name);
    formData.append('mother_name', this.data.mother_name);
    formData.append('address', this.data.address);
    formData.append('flat_number', this.data.flat_number);
    formData.append('city', this.data.city);
    formData.append('pesel', this.data.pesel);
    formData.append('phone', this.data.phone);
    formData.append('dial_code', this.data.dial_code);
    formData.append('postal_code', this.data.postal_code);
    formData.append('message', this.data.message);

    formData.append('is_company', this.data.is_company);
    formData.append('company_name', this.data.company_name);
    formData.append('company_nip', this.data.company_nip);
    formData.append('company_address', this.data.company_address);
    formData.append('company_flat_number', this.data.company_flat_number);
    formData.append('company_postal_code', this.data.company_postal_code);
    formData.append('company_city', this.data.company_city);

    formData.append('father_name', this.data.father_name);
    formData.append('email', this.data.email);
    formData.append('id_card', this.data.id_card);
    formData.append('family_name', this.data.family_name);
    formData.append('birthday', this.data.birthday);
    formData.append('voivodeship', this.data.voivodeship);
    formData.append('county', this.data.county);
    formData.append('post', this.data.post);
    formData.append('tax_office', this.data.tax_office);
    formData.append('correspondence_address', this.data.correspondence_address);
    formData.append('bank_name', this.data.bank_name);
    formData.append('bank_accounting', this.data.bank_accounting);
    formData.append('health_fund', this.data.health_fund);
    formData.append('declaration', this.data.declaration);
    formData.append('persona', this.data.persona);
    formData.append('changes', this.data.changes);

    if (postId) {
      formData.append('doc_id', postId);
    }

    fetch(this.adminURL, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        const urlInput = form.querySelector('input[name="url"]');
        urlInput.value = res.url;

        const submitFormBtn = document.querySelector('.wpcf7-submit');
        submitFormBtn.click();

        this.generatingModal = true;

        this.loading = false;
      });
  },
}));
